import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from "../../config/config";
import { map } from 'rxjs/operators';
import { apiConstants } from "../constant/apiConstant";
import { commonFunctionService } from "../utils/commonFunctions";
@Injectable()
export class TransferCertificateServices {

  private URL_V3 = AppSettings.API_ENDPOINT_V3;

  headers: HttpHeaders;

  constructor(private http: HttpClient, private commonFunction: commonFunctionService) {
   
  }

 

  getWingData(){
    const headers = this.commonFunction.appendHeader(); 
    return this.http.get(this.URL_V3 + `${apiConstants.getWingData}/?lang=en`, { headers }).pipe(map(res => res));
  }

  getClassStandardList(wingId){
    const headers = this.commonFunction.appendHeader(); 
    return this.http.get(this.URL_V3 + `${apiConstants.getClassStandardList}/?lang=en&classCategoryId=${wingId}`, { headers }).pipe(map(res => res));
  }

  getClassSectionData(wingId,classStandardId){
    const headers = this.commonFunction.appendHeader(); 
    return this.http.get(this.URL_V3 + `${apiConstants.getClassSectionData}/?lang=en&classCategoryId=${wingId}&classStandardId=${classStandardId}`, { headers }).pipe(map(res => res));
  }

  getCategoryData(){
    const headers = this.commonFunction.appendHeader(); 
    return this.http.get(this.URL_V3 + `${apiConstants.getCategoryData}/?lang=en`, { headers }).pipe(map(res => res));
  }
  
  getGenderList(){
    const headers = this.commonFunction.appendHeader(); 
    return this.http.get(this.URL_V3 + `${apiConstants.getGenderList}/?lang=en`, { headers }).pipe(map(res => res));
  }


  getStudentTcStats(classCategoryId,classStandardId,classId,castCategory,gender){
    const schoolData = localStorage.getItem("schoolAllInfo");
    const schoolInfo = JSON.parse(schoolData);
    const headers = this.commonFunction.appendHeader(); 
    return this.http.get(this.URL_V3 + `${apiConstants.getTcStatData}/?lang=en&classCategoryId=${classCategoryId}&classStandardId=${classStandardId}&classId=${classId}&gender=${gender}&castCategory=${castCategory}&academicId=${schoolInfo.currentAcademicId}`, { headers }).pipe(map(res => res));
  } 
  
  getTcDetailedInfo(classCategoryId,classStandardId,classId,castCategory,gender,limit,pageNumber){
    const schoolData = localStorage.getItem("schoolAllInfo");
    const schoolInfo = JSON.parse(schoolData);
    const headers = this.commonFunction.appendHeader(); 
    return this.http.get(this.URL_V3 + `${apiConstants.getTcDetailedInfo}/?lang=en&classCategoryId=${classCategoryId}&classStandardId=${classStandardId}&classId=${classId}&gender=${gender}&castCategory=${castCategory}&academicId=${schoolInfo.currentAcademicId}&pageNumber=${pageNumber}&pageLimit=${limit}`, { headers }).pipe(map(res => res));
  }

  exportReportData(body){
    const headers = this.commonFunction.appendHeader();
    return this.http.post(this.URL_V3 + `${apiConstants.exportTcOrBirthCertificateReport}`, body, { headers, responseType: 'blob' as 'json' }).pipe(map(res => res));
  }

}